<template>
    <div class="row align-items-center mt-6" v-loading="loading">
        <div class="col-sm-12 col-md-12">
            <div v-if="!modalEdit" :class="'alert alert-custom alert-light-'+typealert+' fade show py-2'" role="alert">
                <div class="alert-icon"><i class="el-icon-message-solid icon-2x"></i></div>
                <div class="alert-text" v-text="message"></div>
            </div> 
            <el-form ref="formAthlete" :model="formAthlete" status-icon :rules="rules" label-position="left">
                <el-form-item label="Documento" label-width="100px" class="mb-0 text-left" prop="docnumber">
                    <el-input placeholder="Nro de documento" v-model="formAthlete.docnumber" @keypress.enter="searchDoc" class="input-with-select" size="small" 
                        :minlength="formAthlete.doctype== 1 ? 8 : 3" 
                        :maxlength="formAthlete.doctype== 1 ? 8 : 11" :clearable="true" show-word-limit>
                        <template #prepend>
                            <el-select v-model="formAthlete.doctype" placeholder="Seleccione" class="selectdoc">
                                <el-option v-for="item in listDocuments" :key="item.id" :value="item.id" :label="item.name" ></el-option>
                            </el-select>
                        </template>
                        <template v-if="!modalEdit" #append>
                            <el-button type="primary" @click="searchDoc">Buscar</el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <div class="row">
                    <div class="col-sm-4">
                        <el-form-item label="Nombres completos" prop="firstname">
                            <el-input v-model="formAthlete.firstname" :disabled="isDisabled1" size="small" maxlength="50"></el-input>          
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item label="Apellido Paterno" prop="lastname">
                            <el-input v-model="formAthlete.lastname" :disabled="isDisabled1" size="small" maxlength="50"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item label="Apellido Materno" prop="surname">
                            <el-input v-model="formAthlete.surname" :disabled="isDisabled1" size="small" maxlength="50"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-5">
                        <el-form-item label="Sexo" prop="gender" label-width="100px">
                            <el-select v-model="formAthlete.gender" :disabled="isDisabled3"  size="small" placeholder="Selecciona">
                            <el-option v-for="item in listGender" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-7">
                        <el-form-item label="Fecha de nacimiento" prop="birthday" label-width="160px">
                            <el-date-picker v-model="formAthlete.birthday" :disabled="isDisabled4"  type="date" size="small" placeholder="seleccione" :default-value="new Date(2000, 0, 1)" format="DD/MM/YYYY" >
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </div>

                <el-form-item label="Ubigeo" prop="iddistrict" label-width="100px">
                    <el-select v-model="formAthlete.iddistrict" filterable  :disabled="isDisabled2" size="small" placeholder="Departamento/Provincia/Distrito" class="w-100">
                        <el-option v-for="item in currentUbigeo" :key="item.iddistrict" :label="item.name" :value="item.iddistrict"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Dirección" prop="address" label-width="100px">
                        <el-input v-model="formAthlete.address" :disabled="isDisabled2" size="small" maxlength="100"></el-input>
                </el-form-item>

                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item label="Teléfono" label-width="100px" prop="phone1">
                            <el-input  v-model="formAthlete.phone1" :disabled="isDisabled2" size="small" maxlength="9"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Celular" label-width="100px" prop="phone2">
                            <el-input  v-model="formAthlete.phone2" :disabled="isDisabled2" size="small" maxlength="9"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <el-form-item label="Email (1)" prop="email1" label-width="100px">
                    <el-input v-model="formAthlete.email1" :disabled="isDisabled2" size="small" maxlength="100"></el-input>
                </el-form-item>

                <el-form-item label="Email (2)" prop="email2" label-width="100px">
                    <el-input v-model="formAthlete.email2" :disabled="isDisabled2" size="small" maxlength="100"></el-input>
                </el-form-item>
            </el-form>
            <el-divider class="my-4"></el-divider>
            <div class="d-flex justify-content-end" v-if="modalEdit">
                <div class="btn btn-sm btn btn-light mr-3" @click="cancelEdit"><i class="el-icon-close"></i>Cerrar</div>
                <div class="btn btn-sm btn-success" @click="updateForm('formAthlete')">Actualizar <i class="el-icon-edit-outline pr-0"></i></div>
            </div>
            <div class="d-flex justify-content-end" v-else>
                <div class="btn btn-sm btn-secondary mr-3" @click="cancelProcess"><i class="el-icon-close"></i> Cancelar</div>
                <div class="btn btn-sm btn-success"  @click="submitForm('formAthlete')">Siguiente <i class="el-icon-arrow-right pr-0"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import dataJson from "@/data/common";
import { mapGetters } from "vuex";

//stores
import { STEP, MODAL_NEW, MODAL_EDIT } from "@/store/step.module";
import { REGISTER_ATHLETE, UPDATE_ATHLETE } from "@/store/acreditation.module";
//services
import { athleteService, athleteError } from "@/core/services/athlete.service";
import code from "@/core/config/status.code";

export default {
  props: {
    athletedata: {
      type: Object,
      default: () => {}
    },
  },
  data: () => ({
        loading: false,
        maxlength:0,
        minlength:0,
        message: 'Ingrese número de documento luego presionar[Enter] para realizar la búsqueda',
        typealert: 'success',
        isDisabled1: true,
        isDisabled2: true,
        isDisabled3: true,
        isDisabled4: true,
        listDocuments: dataJson.documents,
        listGender: dataJson.gender,
        formAthlete:{
            tpoSearch: 0,
            doctype: null,
            docnumber: null,
            firstname: null,
            lastname: null,
            surname: null,
            gender: null,
            birthday: '',
            iddistrict: '',
            address: '',
            phone1: '',
            phone2: '',
            email1: '',
            email2: ''
        },
        rules: {
            docnumber: [
                {required: true, message: 'Ingrese nro. documento',trigger: 'blur'},
            ],
            firstname: [
                {required: true,message: 'Ingrese nombres completos',trigger: 'blur'},
                {min: 2,max: 50,message: 'Longitud mín. de 2 a 50 carácteres',trigger: 'blur'}
            ],
            lastname: [
                {required: true,message: 'Ingrese apellido paterno',trigger: 'blur'},
                {min: 2,max: 50,message: 'Longitud mín. de 2 a 50 carácteres',trigger: 'blur'}
            ],
            surname: [
                {required: true,message: 'Ingrese apellido materno',trigger: 'blur'},
                {min: 2,max: 50,message: 'Longitud mín. de 2 a 50 carácteres',trigger: 'blur'}
            ],
            gender: [{required: true,message: 'Seleccione género',trigger: ['change', 'blur']}],
            iddistrict: [{required: true,message: 'Seleccione ubigeo',trigger: ['change', 'blur']}],
            address: [
                {required: true,message: 'Ingrese dirección',trigger: 'blur'},
                {min: 3,max: 100,message: 'Longitud mín. de 3 a 100 carácteres',trigger: 'blur'}
            ],
            phone1: [
                {required: true,message: 'Ingrese número de teléfono'},
                {min: 6,max: 9,message: 'Mínimo son 6 digitos'}
            ],
            phone2: [
                {required: true,message: 'Ingrese número de celular'},
                {min: 9,max: 9,message: 'Celular son 9 dígitos'}
            ],
            email1: [
                {required: true,message: 'Ingrese una dirección de correo electrónico',trigger: 'blur'},
                {type: 'email',message: 'Ingrese una dirección de correo electrónico correcta',trigger: ['blur', 'change']}
            ],
            email2: [{type: 'email',message: 'Ingrese una dirección de correo electrónico correcta',trigger: ['blur', 'change']}]
        }
    }),
    computed: {
        ...mapGetters(["currentAcreditation", "modalEdit", "currentUbigeo"]),
    },
    beforeMount(){
        if(this.modalEdit){
            this.isDisabled2 = false;
            return this.formAthlete = this.athletedata;
        } 
    },
    methods:{
        emptyform(){
            this.formAthlete.firstname = null;
            this.formAthlete.lastname = null;
            this.formAthlete.surname = null;
            this.formAthlete.gender = null;
            this.formAthlete.birthday = '';
            this.formAthlete.iddistrict = '';
            this.formAthlete.address = '';
            this.formAthlete.phone1 = '';
            this.formAthlete.phone2 = '';
            this.formAthlete.email1 = '';
            this.formAthlete.email2 = '';
        },
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if(!valid)
                    return false;

                try {
                    this.loading = true;
                    //console.log(this.currentAcreditation)
                    this.$store.dispatch(REGISTER_ATHLETE, {"acrd": this.currentAcreditation, "athlete": this.formAthlete})
                    .then(() => {
                        this.$store.dispatch(STEP, 1).then(()=>{    
                            this.emptyform();
                            this.loading = false;
                        });
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            dangerouslyUseHTMLString: true,
                            callback: action => {
                                code.Manager(err.errorCode);
                            }
                        });
                    })
                } catch (error) {
                    this.loading = false;
                    this.$notify.error({title: 'Error:', message: error});
                }
                
            });
        },

        updateForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    try {
                        this.loading = true;
                        this.$store.dispatch(UPDATE_ATHLETE, {slug: this.athletedata.idperson, data: this.formAthlete})
                        .then((data) => {
                            this.loading = false;
                            this.$notify.success({title: 'Perefcto', message: 'Datos personales actualizados correctamente.'});
                        })
                        .catch((err) => {
                        console.log('error maldito: ' + err);
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            dangerouslyUseHTMLString: true,
                            callback: action => {
                                code.Manager(e.errorCode);
                            }
                        });
                        });
                    } catch (error) {
                        this.loading = false;
                        this.$notify.error({title: 'Error:', message: error});
                    }
                }
            });
        },
        cancelProcess(){
            this.$store.dispatch(MODAL_NEW, false);
        },
        cancelEdit(){
            this.$store.dispatch(MODAL_EDIT, false);
        },
        async searchDoc(){
            if(this.formAthlete.doctype == null)
                return this.$notify.warning({title: 'Campos vacios', message: 'Falta seleccionar tipo de documento'});

            if(this.formAthlete.docnumber == null || this.formAthlete.docnumber == '')
                return this.$notify.warning({title: 'Campos vacios', message: 'Falta ingresar número de documento'});

            if(this.formAthlete.doctype == 1 && this.formAthlete.docnumber.length<8)
                return this.$notify.warning({title: 'Campos vacios', message: 'DNI tiene que ser 8 dígitos'});

            try {
                this.loading = true;
                this.isDisabled1 = this.isDisabled2 = true;
                this.emptyform();

                const res = await athleteService.search(this.formAthlete);
                this.$refs['formAthlete'].resetFields();
                this.typealert = (res.data.status =='error') ? 'danger' : res.data.status;
                this.message = res.data.message;
                this.formAthlete = res.data.athlete;
                if(res.data.status == 'error') this.isDisabled1 = false;
                if(res.data.athlete.gender == null) this.isDisabled3 = false;
                if(res.data.athlete.birthday == null) this.isDisabled4 = false;
                this.isDisabled2 = false;
                this.loading = false;
            } catch (e) {
                this.loading = false;
                if (e instanceof athleteError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        }
  },
  created(){}
}
</script>
<style scope>
    .selectdoc{width: 190px;}
</style>